import * as ViewModel from '@/core/presenter/viewModel';
import NoActivityData from './NoActivityData';
import TokenTransactionItem from './TokenTransactionItem';
import { MAX_TRANSACTION_ITEMS } from '@/consts';
import { observer } from 'mobx-react-lite';
import ActivityItemInfo from './ActivityItemInfo';
import {
  ALERT_ICON_PATH,
  ASSET_RESET_ICON_PATH,
  BACK_ICON_PATH,
  T_LOGO_ICON_PATH,
  TOKEN_SYMBOL_ICON_PATH,
} from '@/consts/imgPath';

interface IProps {
  tokenTransactions: ViewModel.IResponseActivity[];
  tokenBalance: string;
  tokenKrw: string;
  onClickBackBtn: () => void;
  onClickResetBtn: () => void;
  onClickViewType: (viewType: ViewModel.HomeViewType) => void;
  onResetSelectedAsset: () => void;
  onClickPrevTransactionBtn: () => void;
  onClickCopyBtn: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

const TokenView = observer(
  ({
    tokenTransactions,
    tokenBalance,
    tokenKrw,
    onClickBackBtn,
    onClickResetBtn,
    onClickViewType,
    onResetSelectedAsset,
    onClickPrevTransactionBtn,
    onClickCopyBtn,
  }: IProps) => {
    const handleClickSendBtn = () => {
      onResetSelectedAsset();
      onClickViewType(ViewModel.HomeViewType.SEND);
    };

    return (
      <div className="container">
        <header className="ili-header sticky-header">
          <a href="#" className="back-area" onClick={onClickBackBtn}>
            <img src={BACK_ICON_PATH} alt="back-icon" />
          </a>
          <a className="inner">
            <div className="img">
              <img src={T_LOGO_ICON_PATH} alt="Logo" />
            </div>
            <h1>Takk</h1>
          </a>
          <div className="icon-area">
            <img src={ALERT_ICON_PATH} alt="alert-icon" style={{ opacity: 0 }} />
          </div>
        </header>
        <div className="card-ui">
          <div className="icon-ss">
            <img src={TOKEN_SYMBOL_ICON_PATH} alt="Icon" />
            <h2>더블에스</h2>
            <span className="mn-gray fw-n body-xs">DBS</span>
          </div>
          <div className="total-amount fw-n">
            <h3 className="total-balance">{tokenBalance} DBS</h3>
            <a href="#" className="right" onClick={onClickResetBtn}>
              <img src={ASSET_RESET_ICON_PATH} alt="reset-icon" />
            </a>
          </div>
          <div className="exchange body-xl ml-gray">{tokenKrw} 원</div>
          <div className="button-group">
            <button className="solid" onClick={handleClickSendBtn}>
              보내기
            </button>
            <button className="solid" onClick={() => onClickViewType(ViewModel.HomeViewType.RECEIVE)}>
              받기
            </button>
          </div>
        </div>
        {tokenTransactions.length === 0 && <NoActivityData />}
        {tokenTransactions.length > 0 && (
          <div className="activity-area-ss">
            <ul className="list">
              {tokenTransactions.slice(0, MAX_TRANSACTION_ITEMS).map((tokenTransaction, index) => (
                <TokenTransactionItem tokenTransaction={tokenTransaction} key={index} onClickCopyBtn={onClickCopyBtn} />
              ))}
              <ActivityItemInfo onClickPrevTransactionBtn={onClickPrevTransactionBtn} />
            </ul>
          </div>
        )}
      </div>
    );
  },
);

export default TokenView;
